import classNames from 'classnames'
import React from 'react'

import CTA from '@f/elements/CTA'

import { useClientOnly } from '@f-fertighaus/components/ClientOnly/ClientOnly'

const DesktopMenuItem = ({
  menuItem,
  isOpen,
  postcode,
  onCTAClick,
  onCTAMouseEnter,
  keepOpen
}) => {
  const isMounted = useClientOnly()

  const composeNavigationURL = (menuItemUrl, additionalParams = []) => {
    let navigationURL = isMounted
      ? new URL(`${location.origin}${menuItemUrl}`)
      : menuItemUrl
    if (
      isMounted &&
      postcode &&
      /suche|anbieter/.test(menuItemUrl) &&
      !navigationURL.searchParams.has('delivery_regions__in')
    ) {
      navigationURL.searchParams.append('delivery_regions__in', postcode)
    }

    if (additionalParams.length > 0) {
      additionalParams.forEach(param => {
        if (isMounted) {
          navigationURL.searchParams.append(param.key, param.value)
        } else {
          if (!/\?/.test(navigationURL)) {
            navigationURL += '?'
          }
          navigationURL += `&${param.key}=${param.value}`
        }
      })
    }

    return navigationURL
  }

  const handleListElementFocus = e => {
    if (!isOpen) {
      onCTAMouseEnter(e)
    }
  }

  const isHouseSearchItem = menuItem.type === 'house-list'

  const houseSearchMenu = isHouseSearchItem && (
    <div className={classNames(!isOpen && 'f-visually-hidden')}>
      <nav className='[ f-c-ba-whi ] PageHeader-menu PageHeader-menu__uplifted is-active f-p-a-020'>
        <ul className='f-!list f-d-flc f-fl-gap-020'>
          {menuItem.sub_menu_items.map(submenuItem => {
            return (
              <li key={submenuItem.title}>
                <CTA
                  tag='a'
                  type='text-primary'
                  onFocus={handleListElementFocus}
                  href={composeNavigationURL(
                    submenuItem.url,
                    submenuItem.title === 'Grundrisse'
                      ? [{ key: 'has_floor_plans', value: true }]
                      : []
                  ).toString()}
                  className='[ f-t-mini ] PageHeader-menu-button'
                  data-sel='lnk-ua'
                  wtData={{
                    'CTA-click': {
                      label: submenuItem.tracking_id,
                      location: 'header'
                    }
                  }}>
                  {submenuItem.title}
                </CTA>
              </li>
            )
          })}
        </ul>
      </nav>
    </div>
  )

  return (
    <li
      className={classNames('f-d-inbl', 'PageHeader-nav-item', {
        [menuItem.className]: !!menuItem.className
      })}>
      <CTA
        tag='a'
        type='text'
        className={classNames(
          'f-m-v-010',
          'f-p-a-010',
          'PageHeader-nav-link',
          { 'PageHeader-nav-link--active': isOpen && keepOpen },
          { 'PageHeader-with-submenu': menuItem.sub_menu_items },
          { 'f-pos-rel': menuItem.sub_menu_items },
          { 'is-active': menuItem.active },
          { 'is-open': isOpen && menuItem.sub_menu_items }
        )}
        href={composeNavigationURL(menuItem.url).toString()}
        onClick={onCTAClick}
        onFocus={handleListElementFocus}
        onMouseEnter={onCTAMouseEnter}
        wtData={{
          'CTA-click': {
            location: 'header'
          }
        }}>
        {menuItem.title}
      </CTA>
      {houseSearchMenu}
    </li>
  )
}

export default DesktopMenuItem
